export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";